export const CommissionGroupFormStages = [
  {
    title: "Commission Group",
    sections: [
      {
        name: "",
        fields: [
          {
            name: "g4b_name",
            description: "",
            isNameField: true,
            label: "Name",
            required: true,
            type: "nvarchar",
          },
        ],
      },
    ],
  },
];
